import * as React from 'react';
import { Dispatch } from 'react-redux';

import { StoreState } from '../../../reducers';
import { setActiveItem, toggleEditPanel } from '../../../containers/Editor/actions';
import EditPanel from '../../../containers/Editor/EditPanel';
import EnrichmentPanel from '../../../containers/Editor/EditPanel/EnrichmentPanel';
import ThemesPanel from '../../../containers/Editor/EditPanel/ThemesPanel';
import { getBorderWidth } from '../../../containers/Editor/utils/helpers';
import { EnrichmentType } from '../../../containers/Editor/utils/indesignEditor/constants';
import { EditableType, IGNORE_PAGE_CLICK_CLASSNAME } from '../../../containers/Editor/constants';
import { StyledEnrichmentEditor, Border } from './styles';

interface EnrichmentEditorProps {
	page: number;
	id: string;
	type: EnrichmentType;
	isActive: boolean;
	pageScale: number;
	isEditPanelDisplayed: boolean;
	isThemedItem: boolean;
	dispatch: Dispatch<StoreState>;
}

const EnrichmentEditor = ({
	page,
	id,
	type,
	isActive,
	pageScale,
	isEditPanelDisplayed,
	isThemedItem,
	dispatch,
}: EnrichmentEditorProps) => {
	const handleClick = () => {
		if (!isActive) {
			dispatch(setActiveItem(id, page, null));

			if (!isEditPanelDisplayed) {
				dispatch(toggleEditPanel());
			}
		}
	};

	const renderEditPanel = () => {
		const panels = {
			[type]: <EnrichmentPanel page={page} />,
		};

		if (isThemedItem) {
			panels[EditableType.themes] = <ThemesPanel />;
		}

		return (
			isActive && isEditPanelDisplayed && (
				<EditPanel
					defaultType={type}
					panels={panels}
				/>
			)
		);
	};

	return (
		<>
			<StyledEnrichmentEditor
				className={IGNORE_PAGE_CLICK_CLASSNAME}
				onClick={handleClick}
				onTouchEnd={handleClick}
			>
				{isActive &&
					<Border borderWidth={getBorderWidth(pageScale)} />
				}
			</StyledEnrichmentEditor>
			{renderEditPanel()}
		</>
	);
};

export default EnrichmentEditor;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Editor/EnrichmentEditor/index.tsx